import { Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  
  return (
    <Container sx={{ textAlign: 'center', mt: 4 }}>
      <Typography variant="h3" gutterBottom>
        403 - Forbidden
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        You don't have permission to access this page.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/dashboard')}
      >
        Return to Dashboard
      </Button>
    </Container>
  );
};

export default UnauthorizedPage;